import React from 'react';
import styled from 'styled-components';
import {createSelector} from 'reselect';
import {useSelector} from 'react-redux';

// ICONS
import RatingStarIcon from '../../../../../stories/Icons/RatingStarIcon';

// SELECTOR FNS
import {hotelRatingSelector as hotelRatingSelectorFn} from '../../selectors';

const StarIcon = styled(RatingStarIcon)(
  props => `
  color: ${props.theme.colors.yellow.darkerYellow};
`,
);

const StarWrapper = styled.span`
  width: 1.8rem;
  padding: 0 1px;
`;

const Star = () => (
  <StarWrapper>
    <StarIcon />
  </StarWrapper>
);

const hotelRatingSelector = createSelector([hotelRatingSelectorFn], hotelRating => hotelRating);

function HotelRatingStars() {
  const hotelRating = useSelector(hotelRatingSelector);

  if (!hotelRating) {
    return null;
  }

  return (
    <>
    {new Array(hotelRating).fill(1).map((_, i) => (
      // it is okay to do this because it's  static iteration
      /* eslint-disable react/no-array-index-key */
      <Star key={i} />
    ))}
    </>
  );
}

export default HotelRatingStars;
